import { render, staticRenderFns } from "./Bonus_omad.vue?vue&type=template&id=0bbf508a&scoped=true&"
import script from "./Bonus_omad.vue?vue&type=script&lang=js&"
export * from "./Bonus_omad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf508a",
  null
  
)

export default component.exports